import cn from "app/utils/classnames";

export default function PrivacyPolicy({
  className,
}: React.HTMLProps<HTMLParagraphElement>) {
  return (
    <p
      className={cn(
        "-my-[0.175em] text-center text-xs -tracking-[0.01em] text-black",
        className,
      )}
    >
      By subscribing, you agree to{" "}
      <a
        className="underline"
        target="_blank"
        href="https://www.ted.com/about/our-organization/our-policies-terms/privacy-policy"
      >
        TED’s Privacy Policy
      </a>
    </p>
  );
}
